export const GOOGLE_MAPS_SEARCH_QUERY = 'https://www.google.com/maps/search/?api=1&query='
